module.exports = __webpack_public_path__ + "static/hkgrotesk-semibold-c990d93a23b97ab22da549140b6c5755.woff2";